import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid gap-3 sm:grid-cols-1" }

import { InputRow, MultiCombobox, Combobox } from '@/components/ui/form';
    import { Input } from '@/components/ui/input';
    import { useCompanyClientData } from '@/composables/useCompanyClientData';
    import { useCustomerEmployeeData } from '@/composables/useCustomerEmployeeData';
    import { useI18n } from 'vue-i18n';
    import { usePage } from '@inertiajs/vue3';
    import { computed } from 'vue';
    import type { SharedData, SelectOption } from '@/types';
    import CreditCardInput from '@/components/CreditCardInput.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreditCardForm',
  props: {
    form: {}
  },
  setup(__props: any) {

    const { t, tm } = useI18n();
    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const { customerEmployees } = useCustomerEmployeeData(selectedCompanyId.value);
    const { clientOptions, isPendingClientOptions } = useCompanyClientData(selectedCompanyId.value);

    const typeOptions = computed<SelectOption[]>(() => {
        const map = tm('credit-cards.types') as Record<string, string>;
        return Object.entries(map).map(([value, label]) => ({ value, label }));
    });

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "name",
      label: "credit-cards.form.name"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Input), {
          id: "name",
          modelValue: _ctx.form.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
          placeholder: _unref(t)('credit-cards.form.name')
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "number",
      label: "credit-cards.form.number"
    }, {
      default: _withCtx(() => [
        (_ctx.form.id)
          ? (_openBlock(), _createBlock(_unref(Input), {
              key: 0,
              modelValue: _ctx.form.number,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.number) = $event)),
              disabled: ""
            }, null, 8, ["modelValue"]))
          : (_openBlock(), _createBlock(CreditCardInput, {
              key: 1,
              modelValue: _ctx.form.number,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.number) = $event))
            }, null, 8, ["modelValue"]))
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "type",
      label: "credit-cards.form.type"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Combobox), {
          modelValue: _ctx.form.type,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.type) = $event)),
          options: typeOptions.value,
          placeholder: _unref(t)('credit-cards.form.type')
        }, null, 8, ["modelValue", "options", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "employee_ids",
      label: "credit-cards.form.employee_ids"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(MultiCombobox), {
          modelValue: _ctx.form.employee_ids,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.employee_ids) = $event)),
          options: _unref(customerEmployees),
          placeholder: _unref(t)('credit-cards.form.employee_ids'),
          "label-by": "full_name",
          "value-by": "id"
        }, null, 8, ["modelValue", "options", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "user_ids",
      label: "credit-cards.form.user_ids"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(MultiCombobox), {
          modelValue: _ctx.form.user_ids,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.user_ids) = $event)),
          options: _unref(clientOptions),
          placeholder: _unref(t)('credit-cards.form.user_ids'),
          "label-by": "name",
          "value-by": "id",
          loading: _unref(isPendingClientOptions)
        }, null, 8, ["modelValue", "options", "placeholder", "loading"])
      ]),
      _: 1
    }, 8, ["form"])
  ]))
}
}

})